import { isDevMode } from '@repo/ui/utils/is-dev-mode';

/**
 * Throws an error with the given message if `condition` is true.
 * This helps catch unexpected cases or bugs.
 *
 * @param condition - A boolean  expression. If true, an error is thrown.
 * @param message   - The error message to include in the thrown error.
 *
 * @throws Will throw an `Error` if `condition` is true.
 */
export function invariantWithLog(condition: boolean, message: string): void {
  if (!condition) return;

  // In production, we would also log before throwing
  if (!isDevMode()) {
    // Note: structured logging not yet wired
  }

  throw new Error(message);
}
